module.exports = __webpack_public_path__ + "img/ico_xxfb.ae80f8cd.png";